import { useTranslation } from 'react-i18next';

export const useGA4Event = () => {
  const { i18n } = useTranslation();

  const sendEvent = (
    eventName: string,
    params?: Record<string, any>
  ) => {
    if (window.gtag) {
      window.gtag('event', eventName, {
        ...params,
        language: i18n.language,
      });
    } else {
      console.log('[GA4 Event]', eventName, { ...params, language: i18n.language });
    }
  };

  return { sendEvent };
};
